import React from "react";
import { TreeViewNode } from ".";
import { IconChevronRight, IconChevronUp } from "@tabler/icons-react";
import Tooltip from "components/Tooltip";
import clsx from "clsx";
import { ExclamationIcon } from "@heroicons/react/outline";

const TreeNode = ({
  node,
  onToggle,
  onClick,
  highlightNode,
  children,
  hasAlert,
}: {
  node: TreeViewNode;
  onToggle: (node: TreeViewNode) => TreeViewNode | void;
  onClick?: (node: TreeViewNode) => TreeViewNode | void;
  highlightNode?: boolean;
  children?: React.ReactNode;
  hasAlert?: boolean;
}) => {
  const hasChildren = node.childrenNodes && node.childrenNodes.length > 0;

  function shouldHighlightNode() {
    return node.activeNode && highlightNode;
  }

  return (
    <li>
      <div
        className={clsx(
          "flex px-2 cursor-pointer",
          shouldHighlightNode() ? "bg-indigo-50 rounded-md" : ""
        )}
      >
        <div className="min-w-[18px] mr-1 py-2">
          {hasChildren && (
            <span
              className="cursor-pointer text-gray-500"
              onClick={() => onToggle(node)}
            >
              {node.isOpen ? (
                <IconChevronUp width={18} height={18} />
              ) : (
                <IconChevronRight width={18} height={18} />
              )}
            </span>
          )}
        </div>
        <div
          className="flex overflow-hidden py-2 items-center"
          onClick={() => onClick?.(node)}
        >
          <span>{node.icon}</span>
          <div className="text-gray-800 text-sm font-medium truncate">
            {children || (
              <Tooltip content={node.name} truncate>
                {node.name}
              </Tooltip>
            )}
          </div>
          {node.detail ? (
            <span className="text-indigo-700 px-2 py-[1px] bg-indigo-100 text-xs font-medium rounded-lg ml-1.5">
              {node.detail}
            </span>
          ) : null}
          {node.hasAlert ? (
            <ExclamationIcon
              className="min-h-[15px] min-w-[15px] text-yellow-700 ml-2"
              aria-hidden="true"
              strokeWidth={3}
              width={15}
              height={15}
            />
          ) : null}
        </div>
      </div>
      {hasChildren && node.isOpen && (
        <ul className="pl-3">
          {node.childrenNodes.map((child, index) => (
            <TreeNode
              key={index}
              node={child}
              onToggle={onToggle}
              onClick={onClick}
              highlightNode={highlightNode}
            />
          ))}
        </ul>
      )}
    </li>
  );
};

export default TreeNode;
